export enum UserAction {
  DELETE_USER = 'Delete User',
  SUSPEND_USER = 'Suspend User',
  ACTIVATE_USER = 'Activate User',
  RESET_PASSWORD = 'Reset Password',
  EDIT_USER = 'Edit User',
}
